import React from 'react';
import { Text, View } from 'react-native';
import { getMediumFont, getRegularFont } from '../../utils/Utils';
import { creditCardNumber, userAddress, userNameSM } from '../../utils/DictionaryManagementUtils';

const RecipientInformation = ({
  globJSON,
  simPlatform,
  subCategoryId,
  manualName,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { recipient } = globJSON.configurations.services[subCategoryId];
  const manual_recipient = recipient.manual_recipients[manualName];

  const myStyles = {
    container: {
      marginTop: 7,
      borderRadius: globJSON.configurations.theme.radius.elements_shape_square ? 3 : 9,
      backgroundColor: colors.light_elements_color,
      padding: 7,
    },
    title: {
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      fontSize: 7.5,
      color: colors.secondary_font_color,
      marginBottom: 5,
    },
    userNameStyle: {
      fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
      fontSize: 10.4,
      color: colors.primary_font_color,
      marginBottom: 3,
    },
    userAddress: {
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      fontSize: 9.3,
      color: colors.primary_font_color,
    },
  };
  return (
    <View style={myStyles.container}>
      <Text style={myStyles.title}>
        {manual_recipient.recipient_information}
      </Text>
      <Text style={myStyles.userNameStyle}>
        {userNameSM}
      </Text>
      <Text style={myStyles.userAddress}>
        {creditCardNumber}
      </Text>
      <Text style={myStyles.userAddress}>
        {userAddress}
      </Text>
    </View>

  );
};
export default RecipientInformation;
